import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from '/Users/changcheng/Sites/localhost/funda-ui-doc-dev/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
// Simulate request latency
// query from "slug"
// `getList()` must be a Promise Object
// level 1
// level 2
// level 3
/*
{
"key": "2",
"slug": "5",
"link": "#",
"optiondata": "{\"title\":\"xxxxx\",\"link\":\"#\",\"selected\":false,\"slug\":5,\"key\":\"2\",\"show\":true}"
}
*/
// prevent orginal data
// 
// do something...
// If there is no parent id (when recursing for the first time), all parents will be queried
// Query all child nodes by parent node ID
// Query all child nodes by parent node ID
// do something, such as update `<Scrollbar />`
// ...
// If there is no parent id (when recursing for the first time), all parents will be queried
// Query all child nodes by parent node ID
// Query all child nodes by parent node ID
// 
// root area
// do something, such as update `<Scrollbar />`
// ...
// Avoid fatal errors causing page crashes
// list live search
// delete current item children
/*LIST LIVE SEARCH*/
/*/LIST LIVE SEARCH*/
// insert a new <li>
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from '../../src/components/InitMenu';
import React, {useEffect, useState, useRef} from "react";
import Tree from 'funda-ui/Tree';
import 'funda-ui/Tree/index.css';
export const treeData = [{
  title: "Top level 1",
  link: "#",
  slug: 'level-1',
  active: true,
  children: [{
    title: "<span style='color:red;'>Sub level 1_1</span>",
    link: "#1-1",
    slug: 'level-1_1',
    active: true,
    children: [{
      title: "Sub Sub Level 1_1",
      link: "#1-1-1",
      slug: 'level-1_1_1',
      children: [{
        title: "Sub Sub Sub Level 1_1",
        link: "#1-1-1-1"
      }]
    }]
  }, {
    title: "Sub level 1_2",
    link: "#1-2",
    slug: 'level-1_2'
  }]
}, {
  title: "Top level 2 (heading)",
  heading: true,
  link: "https://example.com",
  slug: 'level-2'
}, {
  title: "Top level 3",
  icon: `<svg height="15px" width="15px" viewBox="0 0 32 32"><path fill="#000" d="M16,1C9.925,1,5,5.925,5,12c0,10,10,19,11,19s11-9,11-19C27,5.925,22.075,1,16,1z M16,16c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C20,14.209,18.209,16,16,16z"/></svg>`,
  link: "#",
  slug: 'level-3',
  children: [{
    title: "Sub level 3_1",
    link: "#",
    slug: 'level-3_1'
  }, {
    title: "Sub level 3_2",
    link: "#",
    slug: 'level-3_2'
  }, {
    title: "Sub level 3_3",
    link: "#",
    slug: 'level-3_3',
    disabled: true
  }]
}, {
  title: "Top level 4",
  link: "/s",
  slug: 'level-4'
}, {
  title: "Top level 5",
  link: "/k",
  slug: 'level-5',
  active: true,
  children: [{
    title: "Sub level 5_1",
    link: "/u",
    slug: 'level-5_1'
  }]
}, {
  title: "Top level 6",
  link: "/k",
  slug: 'level-6'
}, {
  title: "Top level 7",
  link: "#",
  slug: 'level-7'
}];
export const treeData2 = [{
  title: "Top level 1",
  link: "#",
  slug: 'level-1'
}, {
  title: "Top level 2",
  link: "/s",
  slug: 'level-2'
}, {
  title: "Top level 3",
  link: "/k",
  slug: 'level-3',
  active: true,
  children: [{
    title: "Sub level 3_1",
    link: "#3-1",
    slug: 'level-3_1'
  }, {
    title: "Sub level 3_2",
    link: "#3-2",
    slug: 'level-3_2'
  }, {
    title: "Sub level 3_3",
    link: "#3-3",
    slug: 'level-3_3'
  }]
}];
export const treeData3 = [{
  title: "Top level 1",
  link: "#",
  slug: 'level-1',
  childrenAsync: true
}, {
  title: "Top level 2",
  link: "/s",
  slug: 'level-2',
  childrenAsync: true
}, {
  title: "Top level 3",
  link: "/k",
  slug: 'level-3',
  active: true,
  children: [{
    title: "Sub level 3_1",
    link: "#3-1",
    slug: 'level-3_1',
    childrenAsync: true
  }, {
    title: "Sub level 3_2",
    link: "#3-2",
    slug: 'level-3_2'
  }, {
    title: "Sub level 3_3",
    link: "#3-3",
    slug: 'level-3_3'
  }]
}];
export const treeData4 = [{
  title: "Top level 1",
  link: "#",
  slug: 'level-1',
  checked: true
}, {
  title: "Top level 2",
  link: "/s",
  slug: 'level-2',
  checked: false,
  children: [{
    title: "Sub level 2_1",
    link: "#2-1",
    slug: 'level-2_1',
    checked: false
  }, {
    title: "Sub level 2_2",
    link: "#2-2",
    slug: 'level-2_2',
    checked: false
  }]
}, {
  title: "Top level 3",
  link: "/k",
  slug: 'level-3',
  checked: false,
  active: true,
  children: [{
    title: "Sub level 3_1",
    link: "#3-1",
    slug: 'level-3_1',
    checked: false
  }, {
    title: "Sub level 3_2",
    link: "#3-2",
    slug: 'level-3_2',
    checked: false
  }, {
    title: "Sub level 3_3",
    link: "#3-3",
    slug: 'level-3_3',
    checked: true
  }]
}];
export class DataService {
  async getList(searchStr = '', limit = 0, otherParam = '') {
    console.log('searchStr: ', searchStr);
    console.log("limit: ", limit);
    console.log("otherParam: ", otherParam);
    let demoData = [];
    // Simulate request latency
    await new Promise(resolve => setTimeout(resolve, 500));
    // query from "slug"
    if (otherParam === 'level-1') {
      demoData = [{
        "parent_id": 0,
        "id": 999,
        "item_name": "Title 999",
        "item_type": "web"
      }];
    }
    if (otherParam === 'level-2') {
      demoData = [{
        "parent_id": 0,
        "id": 1,
        "item_name": "Title 1",
        "item_type": "web"
      }, {
        "parent_id": 0,
        "id": 2,
        "item_name": "Title 2",
        "item_type": "dev"
      }];
    }
    if (otherParam === 'level-3_1') {
      demoData = [{
        "parent_id": 0,
        "id": 3,
        "item_name": "Title 3",
        "item_type": "web"
      }, {
        "parent_id": 0,
        "id": 4,
        "item_name": "Title 4",
        "item_type": "dev"
      }];
    }
    return {
      code: 0,
      message: 'OK',
      data: demoData
    };
  }
}
export class DataService2 {
  // `getList()` must be a Promise Object
  async getList(searchStr = '', limit = 0, otherParam = '') {
    const demoData = [{
      // level 1
      "parent_id": 0,
      "id": 1,
      "item_name": "Title 1",
      "item_type": "web"
    }, {
      "parent_id": 0,
      "id": 2,
      "item_name": "Title 2",
      "item_type": "dev"
    }, {
      // level 2
      "parent_id": 1,
      "id": 3,
      "item_name": "Title 3",
      "item_type": "web/ui"
    }, {
      "parent_id": 1,
      "id": 4,
      "item_name": "Title 4",
      "item_type": "web/ui"
    }, {
      "parent_id": 2,
      "id": 5,
      "item_name": "Title 5",
      "item_type": "dev"
    }, {
      // level 3
      "parent_id": 4,
      "id": 6,
      "item_name": "Title 6",
      "item_type": "web/ui/photoshop"
    }];
    return {
      code: 0,
      message: 'OK',
      data: demoData
    };
  }
}
export const Demo2 = () => {
  const _components = Object.assign({
    a: "a"
  }, _provideComponents());
  const [data, setData] = useState(treeData2);
  function handleClick(e) {
    e.preventDefault();
    setData([{
      title: "(new) Top level 1",
      link: "#",
      slug: 'level-1-new',
      children: [{
        title: "Sub level 1_1",
        link: "#",
        slug: 'level-1_1-new'
      }]
    }, {
      title: "(new)  Top level 2",
      link: "/u",
      slug: 'level-2-new'
    }]);
  }
  return <>

            <_components.a href="#" onClick={handleClick}>change data</_components.a>
            
            <Tree data={data} showLine={true} onSelect={(e, val) => {
    console.log(val);
  }} />


        </>;
};
export const Demo4 = () => {
  const [data, setData] = useState([]);
  function convertTree(arr, parentId = '', keyId = 'id', keyParentId = 'parent_id') {
    if (!parentId) {
      // If there is no parent id (when recursing for the first time), all parents will be queried
      return arr.filter(item => !item[keyParentId]).map(item => {
        // Query all child nodes by parent node ID
        item.children = convertTree(arr, item[keyId], keyId, keyParentId);
        return item;
      });
    } else {
      return arr.filter(item => item[keyParentId] === parentId).map(item => {
        // Query all child nodes by parent node ID
        item.children = convertTree(arr, item[keyId], keyId, keyParentId);
        return item;
      });
    }
  }
  useEffect(() => {
    new DataService2().getList('', 0, '').then(response => {
      // do something, such as update `<Scrollbar />`
      // ...
      const _data = response.data.map((item, i) => {
        return {
          id: item.id,
          parent_id: item.parent_id,
          active: false,
          title: `${item.item_name}`,
          link: "#",
          slug: item.id
        };
      });
      const treeData = convertTree(_data);
      setData(treeData);
    });
  }, []);
  return <>

            <Tree data={data} showLine={true} checkable={true} onCheck={val => {
    console.log(val);
  }} onSelect={(e, val) => {
    console.log(val);
  }} />



        </>;
};
export const Demo5 = () => {
  const _components = Object.assign({
    div: "div",
    a: "a"
  }, _provideComponents());
  const listRef = useRef(null);
  const [data, setData] = useState([]);
  function convertTree(arr, parentId = '', keyId = 'id', keyParentId = 'parent_id') {
    if (!parentId) {
      // If there is no parent id (when recursing for the first time), all parents will be queried
      return arr.filter(item => !item[keyParentId]).map(item => {
        // Query all child nodes by parent node ID
        item.children = convertTree(arr, item[keyId], keyId, keyParentId);
        return item;
      });
    } else {
      return arr.filter(item => item[keyParentId] === parentId).map(item => {
        // Query all child nodes by parent node ID
        item.children = convertTree(arr, item[keyId], keyId, keyParentId);
        return item;
      });
    }
  }
  function handleTreeItemLinkEnter(e) {
    e.preventDefault();
    if (listRef.current === null) return;
    // 
    const slug = e.currentTarget.dataset.slug;
    const controlArea = listRef.current.querySelector(`[data-control-slug="${slug}"]`);
    if (controlArea !== null) {
      controlArea.classList.add('active');
    }
    // root area
    const controlRootArea = listRef.current.querySelector(`[data-control-slug="0"]`);
    if (controlRootArea !== null) {
      controlRootArea.classList.add('active');
    }
  }
  function handleTreeItemLinkLeave(e) {
    if (listRef.current === null) return;
    const slug = e.currentTarget.dataset.slug;
    const controlArea = listRef.current.querySelector(`[data-control-slug="${slug}"]`);
    if (controlArea !== null) {
      controlArea.classList.remove('active');
    }
  }
  useEffect(() => {
    new DataService2().getList('', 0, '').then(response => {
      // do something, such as update `<Scrollbar />`
      // ...
      const _data = response.data.map((item, i) => {
        return {
          id: item.id,
          parent_id: item.parent_id,
          active: false,
          title: `${item.item_name}`,
          link: "#",
          slug: item.id,
          itemLinkMouseEnterCallback: handleTreeItemLinkEnter,
          itemLinkMouseLeaveCallback: handleTreeItemLinkLeave,
          customContentToHyperlink: <>
                        <_components.div className="app-tree-item-control" data-control-slug={item.id}>
                            <_components.a tabIndex={-1} href="#" data-control-slug={item.id} onClick={e => {
            e.preventDefault();
            console.log('item.id: ', e.currentTarget.dataset.controlSlug);
          }} className="btn btn-info btn-sm text-light ms-2">
                                Button
                            </_components.a>
    
                        </_components.div>
                    </>
        };
      });
      const treeData = convertTree(_data);
      setData(treeData);
    });
  }, []);
  return <>

            <_components.div ref={listRef}>

                <Tree data={data} showLine={true} onSelect={(e, val) => {
    console.log(val);
  }} />
            </_components.div>


        </>;
};
export const ListLiveSearch = props => {
  const _components = Object.assign({
    div: "div",
    input: "input",
    button: "button",
    svg: "svg",
    path: "path"
  }, _provideComponents());
  const {listdata, placeholder, exClass, onChange, onSubmit} = props;
  const inputRef = useRef(null);
  const [data, setData] = useState([]);
  const filterRes = (inputData, val) => {
    return inputData.filter(item => {
      // Avoid fatal errors causing page crashes
      const _val = typeof val !== 'undefined' && val !== null ? val : '';
      if (item.title.toLowerCase().indexOf(_val.toLowerCase()) >= 0 && _val != '') {
        return true;
      } else {
        return false;
      }
    });
  };
  function handleChange(e) {
    if (inputRef.current === null) return;
    const _val = e.target.value;
    onChange?.(e, filterRes(data, _val), inputRef.current);
    if (_val === '') {
      onSubmit?.(e, filterRes(data, _val), inputRef.current);
    }
  }
  function handleSubmit(e) {
    e.preventDefault();
    if (inputRef.current === null) return;
    const _val = inputRef.current.value;
    onSubmit?.(e, filterRes(data, _val), inputRef.current);
  }
  function handleKeyPressed(e) {
    if (inputRef.current === null) return;
    const _val = inputRef.current.value;
    if (e.keyCode === 13) {
      e.preventDefault();
      onSubmit?.(e, filterRes(data, _val), inputRef.current);
    }
  }
  useEffect(() => {
    setData(listdata);
  }, [listdata]);
  return <>

            <_components.div className={`input-group ${exClass || 'mb-1'}`}>
                <_components.input ref={inputRef} autoComplete="off" type="text" className="form-control" placeholder={placeholder || ''} onChange={handleChange} onKeyDown={handleKeyPressed} />
                <_components.div className="input-group-text">
                    <_components.button tabIndex={-1} type="button" className="btn border-end-0 rounded-pill p-0 m-0" onClick={handleSubmit}>
                        <_components.svg width="1em" height="1em" fill="#a5a5a5" viewBox="0 0 16 16">
                            <_components.path d="M12.027 9.92L16 13.95 14 16l-4.075-3.976A6.465 6.465 0 0 1 6.5 13C2.91 13 0 10.083 0 6.5 0 2.91 2.917 0 6.5 0 10.09 0 13 2.917 13 6.5a6.463 6.463 0 0 1-.973 3.42zM1.997 6.452c0 2.48 2.014 4.5 4.5 4.5 2.48 0 4.5-2.015 4.5-4.5 0-2.48-2.015-4.5-4.5-4.5-2.48 0-4.5 2.014-4.5 4.5z" fillRule="evenodd" />
                        </_components.svg>
                    </_components.button>
                </_components.div>
            </_components.div>

        </>;
};
export const Demo6 = () => {
  // list live search
  const [flatList, setFlatList] = useState([]);
  const [queryData, setQueryData] = useState([]);
  function deepClone(obj) {
    if (Array.isArray(obj)) {
      return obj.map(item => deepClone(item));
    } else if (typeof obj === 'object' && obj !== null) {
      const clone = {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          clone[key] = deepClone(obj[key]);
        }
      }
      return clone;
    } else {
      return obj;
    }
  }
  const flatData = data => {
    const result = [];
    const iterate = obj => {
      if (!obj) {
        return;
      }
      obj.forEach(item => {
        result.push(item);
        if (item.children) {
          iterate(item.children);
        }
        // delete current item children
        delete item.children;
      });
    };
    iterate(data);
    return result;
  };
  useEffect(() => {
    setFlatList(flatData(deepClone(treeData2)));
  }, []);
  return <>

            {}
            <ListLiveSearch listdata={flatList.map(item => {
    return {
      title: item.title
    };
  })} placeholder="Search" onChange={(e, queryData, input) => {
    setQueryData(queryData);
  }} onSubmit={(e, queryData, input) => {
    setQueryData(queryData);
  }} />
            {}

            <Tree retrieveData={queryData} data={treeData2} showLine={true} checkable={true} onCheck={val => {
    console.log(val);
  }} onSelect={(e, val) => {
    console.log(val);
  }} />



        </>;
};
export const Demo7 = () => {
  const _components = Object.assign({
    a: "a",
    br: "br",
    div: "div"
  }, _provideComponents());
  const treeRef = useRef(null);
  return <>

            <_components.a href="#" onClick={e => {
    e.preventDefault();
    treeRef.current?.collapse('level-3');
  }}>Expand "Top level 3"</_components.a>
            <_components.br />
            <_components.a href="#" onClick={e => {
    e.preventDefault();
    const _anyEl = document.querySelector('#demo-7-tree [data-slug="level-1_2"]');
    if (_anyEl !== null) {
      // insert a new <li>
      const targetLi = _anyEl.closest('.nav-item');
      const newLi = document.createElement("li");
      newLi.className = 'nav-item';
      newLi.innerHTML = '<div tabindex="-1" class="nav-link" data-href="#new-item-here" aria-expanded="false" data-link="#new-item-here" data-slug="level-new-item-here" data-key="0-new-item-here" data-optiondata="{}"><span><i style="color:blue">New Item Here</i></span></div>';
      targetLi.parentNode.insertBefore(newLi, targetLi.nextSibling);
    }
    treeRef.current?.updateParentTreeHeights(_anyEl);
  }}>Update the heights of all subtrees of "Top level 1" (Click repeatedly to view the effect) </_components.a>
           
            <_components.div id="demo-7-tree">
                <Tree ref={treeRef} data={treeData} showLine={true} onSelect={(e, val) => {
    console.log(val);
  }} />
            </_components.div>


        </>;
};
export const __toc = [{
  depth: 2,
  value: "General",
  id: "general"
}, {
  depth: 2,
  value: "Asynchronous Usage",
  id: "asynchronous-usage"
}, {
  depth: 2,
  value: "Load Data Asynchronously",
  id: "load-data-asynchronously"
}, {
  depth: 2,
  value: "Using Checkbox",
  id: "using-checkbox"
}, {
  depth: 2,
  value: "Convert raw data into a tree structure",
  id: "convert-raw-data-into-a-tree-structure"
}, {
  depth: 2,
  value: "Push some expansion buttons to each item of the tree",
  id: "push-some-expansion-buttons-to-each-item-of-the-tree"
}, {
  depth: 2,
  value: "Live Search Tree",
  id: "live-search-tree"
}, {
  depth: 2,
  value: "Customize option rendering",
  id: "customize-option-rendering"
}, {
  depth: 2,
  value: "Use the exposed method to expand or update the subtree height",
  id: "use-the-exposed-method-to-expand-or-update-the-subtree-height"
}, {
  depth: 2,
  value: "❤️ API",
  id: "️-api"
}, {
  depth: 3,
  value: "Tree",
  id: "tree"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    blockquote: "blockquote",
    p: "p",
    svg: "svg",
    path: "path",
    details: "details",
    summary: "summary",
    pre: "pre",
    code: "code",
    span: "span",
    strong: "strong",
    div: "div",
    em: "em",
    small: "small",
    h3: "h3",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    a: "a",
    hr: "hr"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"Tree"}</_components.h1>{"\n"}{"\n"}{"\n"}{"\n"}{"\n"}{"\n"}{"\n"}{"\n"}<_components.h2 id="general">{"General"}</_components.h2>{"\n"}<br />{"\n"}<Tree data={treeData} showLine={true} onSelect={(e, val) => {
    /*
    {
    "key": "2",
    "slug": "5",
    "link": "#",
    "optiondata": "{\"title\":\"xxxxx\",\"link\":\"#\",\"selected\":false,\"slug\":5,\"key\":\"2\",\"show\":true}"
    }
    */
    console.log(val);
  }} />{"\n"}<div className="app-separate" />{"\n"}<_components.blockquote>{"\n"}<_components.p>{"Clicking on the node has an expansion effect."}</_components.p>{"\n"}</_components.blockquote>{"\n"}<Tree data={treeData} showLine={false} disableArrow={true} onSelect={(e, val) => {
    console.log(val);
  }} />{"\n"}<div className="app-separate" />{"\n"}<Tree data={treeData} showLine={false} disableArrow={true} disableCollapse={true} onSelect={(e, val) => {
    console.log(val);
  }} />{"\n"}<div className="app-separate" />{"\n"}<Tree data={treeData} showLine={true} arrowIcons={[<><_components.svg width="1em" height="1em" viewBox="0 0 24 24" fill="none"><_components.path d="M12 16V13M12 13V10M12 13H9M12 13H15M3 6V16.8C3 17.9201 3 18.4798 3.21799 18.9076C3.40973 19.2839 3.71547 19.5905 4.0918 19.7822C4.5192 20 5.07899 20 6.19691 20H17.8031C18.921 20 19.48 20 19.9074 19.7822C20.2837 19.5905 20.5905 19.2841 20.7822 18.9078C21.0002 18.48 21.0002 17.9199 21.0002 16.7998L21.0002 9.19978C21.0002 8.07967 21.0002 7.51962 20.7822 7.0918C20.5905 6.71547 20.2839 6.40973 19.9076 6.21799C19.4798 6 18.9201 6 17.8 6H12M3 6H12M3 6C3 4.89543 3.89543 4 5 4H8.67452C9.1637 4 9.40886 4 9.63904 4.05526C9.84311 4.10425 10.0379 4.18526 10.2168 4.29492C10.4186 4.41857 10.5918 4.59182 10.9375 4.9375L12 6" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></_components.svg></>, <><_components.svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
        <_components.path d="M17.8031 20L19.793 20C20.2255 20 20.4419 20 20.6236 19.9258C20.784 19.8603 20.9251 19.7538 21.0322 19.6175C21.1535 19.4631 21.2132 19.2555 21.332 18.8395L22.4177 15.0396C22.6156 14.3472 22.714 14.0009 22.6363 13.7271C22.5682 13.4871 22.4131 13.2813 22.2011 13.15C21.9731 13.0087 21.64 13.0005 21.0002 13M17.8031 20H6.19691M17.8031 20C18.921 20 19.48 20 19.9074 19.7822C20.2837 19.5905 20.5905 19.2841 20.7822 18.9078C21.0002 18.48 21.0002 17.9199 21.0002 16.7998V13M6.19691 20H5.12109C4.40152 20 4.04075 20 3.79883 19.8501C3.58683 19.7187 3.43144 19.5129 3.36338 19.2729C3.34904 19.2224 3.34073 19.1694 3.33796 19.1122M6.19691 20C5.07899 20 4.5192 20 4.0918 19.7822C3.78624 19.6265 3.52721 19.3952 3.33796 19.1122M21.0002 13C20.9608 13 20.9203 13 20.8786 13H5.00028L3.58301 17.9604L3.58096 17.9674C3.42083 18.5278 3.32578 18.8605 3.33796 19.1122M21.0002 13L21.0002 9.19978C21.0002 8.07967 21.0002 7.51962 20.7822 7.0918C20.5905 6.71547 20.2839 6.40973 19.9076 6.21799C19.4798 6 18.9201 6 17.8 6H12M3.33796 19.1122C3.29413 19.0467 3.25404 18.9784 3.21799 18.9076C3 18.4798 3 17.9201 3 16.8V6M3 6H12M3 6C3 4.89543 3.89543 4 5 4H8.67452C9.1637 4 9.40886 4 9.63904 4.05526C9.84311 4.10425 10.0379 4.18526 10.2168 4.29492C10.4186 4.41857 10.5918 4.59182 10.9375 4.9375L12 6" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></_components.svg></>]} onSelect={(e, val) => {
    console.log(val);
  }} />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"<span style='color:red;'>Sub level 1_1</span>\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#1-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub Sub Level 1_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#1-1-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1_1_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub Sub Sub Level 1_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#1-1-1-1\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 1_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#1-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1_2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 2 (heading)\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        heading"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"https://example.com\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        icon"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`<svg height=\"15px\" width=\"15px\" viewBox=\"0 0 32 32\"><path fill=\"#000\" d=\"M16,1C9.925,1,5,5.925,5,12c0,10,10,19,11,19s11-9,11-19C27,5.925,22.075,1,16,1z M16,16c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C20,14.209,18.209,16,16,16z\"/></svg>`"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_1'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_2'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                disabled"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 4\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/s\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-4'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 5\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/k\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-5'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 5_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/u\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-5_1'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 6\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/k\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-6'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 7\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-7'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"/* "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"                {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"                    \"key\": \"2\","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"                    \"slug\": \"5\","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"                    \"link\": \"#\","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"                    \"optiondata\": \"{\\\"title\\\":\\\"xxxxx\\\",\\\"link\\\":\\\"#\\\",\\\"selected\\\":false,\\\"slug\\\":5,\\\"key\\\":\\\"2\\\",\\\"show\\\":true}\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"                } "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"                */"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"blockquote"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Clicking on the node has an expansion effect.</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"blockquote"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"disableArrow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"disableArrow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"disableCollapse"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"arrowIcons"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <><"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"svg"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"width"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1em\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"height"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1em\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"viewBox"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"0 0 24 24\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"fill"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"none\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"><"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"path"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"d"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"M12 16V13M12 13V10M12 13H9M12 13H15M3 6V16.8C3 17.9201 3 18.4798 3.21799 18.9076C3.40973 19.2839 3.71547 19.5905 4.0918 19.7822C4.5192 20 5.07899 20 6.19691 20H17.8031C18.921 20 19.48 20 19.9074 19.7822C20.2837 19.5905 20.5905 19.2841 20.7822 18.9078C21.0002 18.48 21.0002 17.9199 21.0002 16.7998L21.0002 9.19978C21.0002 8.07967 21.0002 7.51962 20.7822 7.0918C20.5905 6.71547 20.2839 6.40973 19.9076 6.21799C19.4798 6 18.9201 6 17.8 6H12M3 6H12M3 6C3 4.89543 3.89543 4 5 4H8.67452C9.1637 4 9.40886 4 9.63904 4.05526C9.84311 4.10425 10.0379 4.18526 10.2168 4.29492C10.4186 4.41857 10.5918 4.59182 10.9375 4.9375L12 6\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"stroke"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#000000\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"strokeWidth"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"strokeLinecap"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"round\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"strokeLinejoin"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"round\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"/></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"svg"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></>"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <><"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"svg"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"width"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1em\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"height"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1em\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"viewBox"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"0 0 24 24\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"fill"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"none\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"path"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"d"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"M17.8031 20L19.793 20C20.2255 20 20.4419 20 20.6236 19.9258C20.784 19.8603 20.9251 19.7538 21.0322 19.6175C21.1535 19.4631 21.2132 19.2555 21.332 18.8395L22.4177 15.0396C22.6156 14.3472 22.714 14.0009 22.6363 13.7271C22.5682 13.4871 22.4131 13.2813 22.2011 13.15C21.9731 13.0087 21.64 13.0005 21.0002 13M17.8031 20H6.19691M17.8031 20C18.921 20 19.48 20 19.9074 19.7822C20.2837 19.5905 20.5905 19.2841 20.7822 18.9078C21.0002 18.48 21.0002 17.9199 21.0002 16.7998V13M6.19691 20H5.12109C4.40152 20 4.04075 20 3.79883 19.8501C3.58683 19.7187 3.43144 19.5129 3.36338 19.2729C3.34904 19.2224 3.34073 19.1694 3.33796 19.1122M6.19691 20C5.07899 20 4.5192 20 4.0918 19.7822C3.78624 19.6265 3.52721 19.3952 3.33796 19.1122M21.0002 13C20.9608 13 20.9203 13 20.8786 13H5.00028L3.58301 17.9604L3.58096 17.9674C3.42083 18.5278 3.32578 18.8605 3.33796 19.1122M21.0002 13L21.0002 9.19978C21.0002 8.07967 21.0002 7.51962 20.7822 7.0918C20.5905 6.71547 20.2839 6.40973 19.9076 6.21799C19.4798 6 18.9201 6 17.8 6H12M3.33796 19.1122C3.29413 19.0467 3.25404 18.9784 3.21799 18.9076C3 18.4798 3 17.9201 3 16.8V6M3 6H12M3 6C3 4.89543 3.89543 4 5 4H8.67452C9.1637 4 9.40886 4 9.63904 4.05526C9.84311 4.10425 10.0379 4.18526 10.2168 4.29492C10.4186 4.41857 10.5918 4.59182 10.9375 4.9375L12 6\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"stroke"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#000000\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"strokeWidth"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"strokeLinecap"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"round\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"strokeLinejoin"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"round\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"/></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"svg"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ]}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="asynchronous-usage">{"Asynchronous Usage"}</_components.h2>{"\n"}<br />{"\n"}{"\n"}<Demo2 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/s\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/k\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_1'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_2'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_3'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">(treeData);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"   "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleClick"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"(new) Top level 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1-new'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 1_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1_1-new'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"(new)  Top level 2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/u\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2-new'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        ]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{handleClick}>change data</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{data} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="load-data-asynchronously">{"Load Data Asynchronously"}</_components.h2>{"\n"}<_components.p>{"To load data asynchronously when click to expand a treeNode."}</_components.p>{"\n"}<br />{"\n"}<Tree data={treeData3} showLine={true} onSelect={(e, val) => {
    console.log(val);
  }} onCollapse={async (e, val, updateData, isExpanded) => {
    console.log(val);
    const updatedList = await updateData(val.key, {
      "fetchFuncAsync": new DataService(),
      "fetchFuncMethod": "getList",
      "fetchFuncMethodParams": ['', 0, val.slug],
      "fetchCallback": res => {
        // prevent orginal data
        let placesMap = {};
        for (const val of res) {
          placesMap[val.id] = [val.item_name, val.item_type, val.id];
        }
        // 
        const data = [];
        for (const key in placesMap) {
          data.push({
            title: placesMap[key][0],
            link: "#",
            slug: placesMap[key][1]
          });
        }
        return data;
      }
    });
    if (typeof updatedList !== 'undefined') {
      // do something...
    }
  }} />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" axios "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"axios\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { UpdateDataFunction } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"class"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"DataService"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"async"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"getList"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(searchStr "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" limit "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" otherParam "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'searchStr: '"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" searchStr);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"limit: \""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" limit);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"otherParam: \""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" otherParam);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"let"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" demoData "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// Simulate request latency"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"await"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"new"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Promise"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(resolve "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setTimeout"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(resolve"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"500"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"));"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// query from \"slug\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ( otherParam "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            demoData "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"999"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 999\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }];   "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ( otherParam "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ) {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            demoData "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"dev\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ];   "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ( otherParam "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ) {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            demoData "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"4"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 4\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"dev\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ];   "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            code"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            message"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'OK'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" demoData"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        };"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"async"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"getListUseAxios"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(searchStr "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" limit "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"let"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" _data "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"res"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"await"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"axios"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".get"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`https://api`"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            params"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                s"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" searchStr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                limit"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" limit"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            headers"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Authorization'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Bearer xxxx-xxxxxxxx-xxxxxxxx'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Content-Type'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{": "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'application/json'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        })"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".catch"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (error) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(error);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        });"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (res "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"&&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"res"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".status "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"200"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") _data "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"res"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".data;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// result"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (_data "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                code"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                message"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'OK'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" []"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            };"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                code"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                message"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'OK'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" _data"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            };"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        childrenAsync"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/s\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        childrenAsync"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/k\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                childrenAsync"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_2'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_3'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onCollapse"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"async"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    updateData: UpdateDataFunction"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    isExpanded: boolean"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"updatedList"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"await"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"updateData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".key"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"fetchFuncAsync\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"new"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" DataService"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"fetchFuncMethod\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"getList\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"fetchFuncMethodParams\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".slug]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"fetchCallback\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (res) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// prevent orginal data"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"let"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" placesMap"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"Record"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"unknown"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]> "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {};"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"for"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"of"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" res) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                placesMap["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".item_name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".item_type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id];"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"//"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [];"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"for"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"key"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"in"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" placesMap) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".push"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"({"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                    title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" placesMap[key]["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" placesMap[key]["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                });"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" data;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    });"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"typeof"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" updatedList "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'undefined'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// do something..."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="using-checkbox">{"Using Checkbox"}</_components.h2>{"\n"}<_components.p>{"Add a Checkbox before the tree nodes."}</_components.p>{"\n"}<br />{"\n"}<Tree data={treeData4} showLine={true} checkable={true} onCheck={val => {
    console.log(val);
  }} onSelect={(e, val) => {
    console.log(val);
  }} />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/s\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 2_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#2-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 2_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#2-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2_2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/k\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checkable"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onCheck"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(val) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="convert-raw-data-into-a-tree-structure">{"Convert raw data into a tree structure"}</_components.h2>{"\n"}<br />{"\n"}{"\n"}<Demo4 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useEffect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"class"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"DataService"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// `getList()` must be a Promise Object"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"async"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"getList"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(searchStr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" limit"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"number"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" otherParam"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"demoData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// level 1"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"dev\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// level 2"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web/ui\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"4"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 4\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web/ui\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"5"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 5\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"dev\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// level 3"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"4"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"6"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 6\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web/ui/photoshop\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        ];   "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            code"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            message"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'OK'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" demoData"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        };"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"/**"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * Convert Tree"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@param"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"{Array}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" arr                    - Input array to convert"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@param"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"{?String | ?Number}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" parentId  - Parent id"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@param"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"{?String}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" keyId               - Key value of id."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@param"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"{?String}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" keyParentId         - Key value of parent id."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@returns"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" Array"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     */"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"convertTree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" parentId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'id'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyParentId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'parent_id'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"( "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"parentId ) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// If there is no parent id (when recursing for the first time), all parents will be queried"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".filter"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"item[keyParentId])"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// Query all child nodes by parent node ID"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".children "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"convertTree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item[keyId]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyParentId);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            })"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".filter"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item[keyParentId] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" parentId)"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// Query all child nodes by parent node ID"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".children "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"convertTree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item[keyId]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyParentId);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            })"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useEffect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(() "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"new"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"DataService"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"()"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".getList"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".then"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((response"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"response"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"number"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    parent_id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".parent_id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"${"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".item_name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            });"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"         "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"convertTree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(_data);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(treeData);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// do something, such as update `<Scrollbar />`"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// ..."}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        });"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" []);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{data} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checkable"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onCheck"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(val) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="push-some-expansion-buttons-to-each-item-of-the-tree">{"Push some expansion buttons to each item of the tree"}</_components.h2>{"\n"}<_components.p>{"Use those attributes of "}<_components.code>{"customContentToHyperlink"}</_components.code>{", "}<_components.code>{"customContentToLiTag"}</_components.code>{", "}<_components.code>{"itemLinkMouseEnterCallback"}</_components.code>{", "}<_components.code>{"itemLinkMouseLeaveCallback"}</_components.code>{", "}<_components.code>{"itemMouseEnterCallback"}</_components.code>{", "}<_components.code>{"itemMouseLeaveCallback"}</_components.code>{" in the data item to create interactions and UI."}</_components.p>{"\n"}<br />{"\n"}{"\n"}<Demo5 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-css3-alt px-2" />{" Show Code ["}<_components.strong>{"styles.scss"}</_components.strong>{"]"}</_components.summary><_components.pre data-language="css" data-theme="default" hasCopyCode><_components.code data-language="css" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"/* ---------- Tree Control  ----------- */"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".app-tree-item-control"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"position"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"absolute"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"top"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{".45"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"rem"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"right"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"z-index"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"background"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"#fff"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"border-radius"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"4"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"px"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"padding"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0 .2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"rem"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"transform"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"scale"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"(0)"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"transition"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{".1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"s"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{" ease-in-out"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"transition-delay"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0.25"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"s"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    &."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"active"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"transform"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"scale"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"(1)"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code ["}<_components.strong>{"index.tsx"}</_components.strong>{"]"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useEffect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useState"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useRef } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"class"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"DataService"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// `getList()` must be a Promise Object"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"async"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"getList"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(searchStr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" limit"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"number"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" otherParam"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"demoData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// level 1"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"dev\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// level 2"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web/ui\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"4"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 4\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web/ui\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"5"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 5\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"dev\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// level 3"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"parent_id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"4"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"id\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"6"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_name\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Title 6\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"item_type\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"web/ui/photoshop\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        ];   "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            code"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            message"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'OK'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" demoData"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        };"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"listRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLDivElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"/**"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * Convert Tree"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@param"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"{Array}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" arr                    - Input array to convert"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@param"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"{?String | ?Number}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" parentId  - Parent id"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@param"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"{?String}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" keyId               - Key value of id."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@param"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"{?String}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" keyParentId         - Key value of parent id."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     * "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@returns"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{" Array"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"     */"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"convertTree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" parentId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'id'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyParentId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'parent_id'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"( "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"parentId ) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// If there is no parent id (when recursing for the first time), all parents will be queried"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".filter"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"item[keyParentId])"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// Query all child nodes by parent node ID"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".children "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"convertTree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item[keyId]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyParentId);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            })"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".filter"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item[keyParentId] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" parentId)"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// Query all child nodes by parent node ID"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".children "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"convertTree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(arr"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item[keyId]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyId"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" keyParentId);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" item;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            })"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleTreeItemLinkEnter"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"listRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"//"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"slug"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"currentTarget"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dataset"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".slug;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"controlArea"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"listRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".querySelector"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`[data-control-slug=\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"${"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"]`"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (controlArea "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"controlArea"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"classList"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".add"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'active'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// root area"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"controlRootArea"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"listRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".querySelector"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`[data-control-slug=\"0\"]`"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (controlRootArea "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"controlRootArea"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"classList"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".add"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'active'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleTreeItemLinkLeave"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"listRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"slug"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"currentTarget"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dataset"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".slug;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"controlArea"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"listRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".querySelector"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`[data-control-slug=\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"${"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"]`"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (controlArea "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"controlArea"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"classList"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".remove"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'active'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useEffect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(() "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"new"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"DataService"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"()"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".getList"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".then"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((response"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"response"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"number"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    parent_id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".parent_id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"${"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".item_name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    itemLinkMouseEnterCallback"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" handleTreeItemLinkEnter"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    itemLinkMouseLeaveCallback"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" handleTreeItemLinkLeave"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    customContentToHyperlink"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" <>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"app-tree-item-control\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data-control-slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id}>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"tabIndex"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data-control-slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'item.id: '"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".currentTarget "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"as"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"dataset"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".controlSlug);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"btn btn-info btn-sm text-light ms-2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            >"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                Button"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    </>"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            });"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"         "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"convertTree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(_data);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(treeData);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// do something, such as update `<Scrollbar />`"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// ..."}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        });"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" []);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ref"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{listRef}>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{data}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="live-search-tree">{"Live Search Tree"}</_components.h2>{"\n"}<_components.p>{"Use the "}<_components.code>{"retrieveData"}</_components.code>{" attribute to display real-time search content."}</_components.p>{"\n"}<br />{"\n"}{"\n"}{"\n"}<Demo6 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code ["}<_components.strong>{"ListLiveSearch.tsx"}</_components.strong>{"]"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useEffect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useRef} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"interface"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ListLiveSearchDataConfig"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"number"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ListLiveSearchProps"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    listdata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[];"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    placeholder"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    exClass"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" el"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"void"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSubmit"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" el"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"void"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"};"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ListLiveSearch"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (props"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ListLiveSearchProps"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"listdata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"placeholder"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"exClass"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"onSubmit"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" props;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ListLiveSearchDataConfig"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"   "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"filterRes"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (inputData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"string"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".filter"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// Avoid fatal errors causing page crashes"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"typeof"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'undefined'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"&&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".toLowerCase"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"()"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".indexOf"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_val"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".toLowerCase"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"()) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"&&"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                _val "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            ) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        });"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleChange"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"target"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange?."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"filterRes"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" _val)"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (_val "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSubmit?."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"filterRes"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" _val)"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleSubmit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSubmit?."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"filterRes"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" _val)"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleKeyPressed"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".value;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".keyCode "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"13"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSubmit?."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"filterRes"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" _val)"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"inputRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".current);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useEffect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(() "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(listdata);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [listdata])"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`input-group "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"${"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"exClass "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"||"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'mb-1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"input"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ref"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{inputRef} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"autoComplete"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"off\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"text\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"form-control\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"placeholder"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{placeholder "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"||"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"''"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{handleChange} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onKeyDown"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{handleKeyPressed}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"input-group-text\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"tabIndex"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"button\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"btn border-end-0 rounded-pill p-0 m-0\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{handleSubmit}>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"svg"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"width"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1em\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"height"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1em\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"fill"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#a5a5a5\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"viewBox"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"0 0 16 16\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"path"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"d"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"M12.027 9.92L16 13.95 14 16l-4.075-3.976A6.465 6.465 0 0 1 6.5 13C2.91 13 0 10.083 0 6.5 0 2.91 2.917 0 6.5 0 10.09 0 13 2.917 13 6.5a6.463 6.463 0 0 1-.973 3.42zM1.997 6.452c0 2.48 2.014 4.5 4.5 4.5 2.48 0 4.5-2.015 4.5-4.5 0-2.48-2.015-4.5-4.5-4.5-2.48 0-4.5 2.014-4.5 4.5z\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"fillRule"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"evenodd\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"svg"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    );"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ListLiveSearch;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code ["}<_components.strong>{"index.tsx"}</_components.strong>{"]"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useState"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useEffect} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ListLiveSearch "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'./ListLiveSearch'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/s\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 2_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#2-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 2_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#2-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2_2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/k\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"false"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#3-3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// list live search"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"flatList"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setFlatList"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"queryData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setQueryData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"deepClone"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(obj"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Array"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".isArray"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(obj)) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (obj "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"as"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"deepClone"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(item));"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"typeof"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" obj "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"==="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'object'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"&&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" obj "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"clone"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {};"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"for"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"let"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" key "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"in"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" obj) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"obj"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".hasOwnProperty"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(key)) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    clone[key] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"deepClone"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(obj[key]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" clone;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" obj;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"flatData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"result"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [];"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"iterate"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (obj"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"obj) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"obj"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".forEach"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"result"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".push"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(item);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".children) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"iterate"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".children);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// delete current item children"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"delete"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".children;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            })"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"iterate"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(data);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" result;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    };"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useEffect"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(() "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setFlatList"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"flatData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"deepClone"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(treeData)));"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" []);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"/* LIST LIVE SEARCH */"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"ListLiveSearch"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"listdata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"flatList"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".title"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                })}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"placeholder"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Search\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" queryData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" input"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLInputElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setQueryData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(queryData);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSubmit"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" queryData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" input"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"HTMLInputElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setQueryData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(queryData);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"/* /LIST LIVE SEARCH */"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"retrieveData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{queryData}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checkable"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onCheck"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(val) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="customize-option-rendering">{"Customize option rendering"}</_components.h2>{"\n"}<_components.p><_components.code>{"renderOption"}</_components.code>{" callback allows you to customize the UI style for the output of each option."}</_components.p>{"\n"}<br />{"\n"}<Tree data={treeData} showLine={true} onSelect={(e, val) => {
    console.log(val);
  }} renderOption={(optionData, key) => {
    return <_components.div style={optionData.disabled ? {
      pointerEvents: 'none',
      opacity: .3
    } : undefined}>
            <_components.em>{key}. </_components.em>
            <_components.strong dangerouslySetInnerHTML={{
      __html: `${optionData.title}`
    }}></_components.strong>
            <_components.div><_components.small style={{
      color: 'gray'
    }}>value: {optionData.slug}</_components.small></_components.div>
        </_components.div>;
  }} />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { DataNode } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"     "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);    "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"renderOption"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(optionData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"DataNode"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" key"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"Key"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"style"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"optionData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".disabled "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {pointerEvents"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'none'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" opacity"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{".3"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"undefined"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"em"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">{key}. </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"em"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"strong"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dangerouslySetInnerHTML"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                                    __html"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"${"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"optionData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"}"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        }}></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"strong"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"><"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"small"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"style"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{{color"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'gray'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}}>value: {"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"optionData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".slug}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"small"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="use-the-exposed-method-to-expand-or-update-the-subtree-height">{"Use the exposed method to expand or update the subtree height"}</_components.h2>{"\n"}<_components.p>{"Lets you callback the handle exposed as attribute "}<_components.code>{"ref"}</_components.code>{"."}</_components.p>{"\n"}<br />{"\n"}{"\n"}<Demo7 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useRef } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'react'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { TreeRef } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// component styles"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree/index.css'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"<span style='color:red;'>Sub level 1_1</span>\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#1-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub Sub Level 1_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#1-1-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1_1_1'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub Sub Sub Level 1_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#1-1-1-1\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 1_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#1-2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-1_2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 2 (heading)\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        heading"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"https://example.com\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-2'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        icon"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"`<svg height=\"15px\" width=\"15px\" viewBox=\"0 0 32 32\"><path fill=\"#000\" d=\"M16,1C9.925,1,5,5.925,5,12c0,10,10,19,11,19s11-9,11-19C27,5.925,22.075,1,16,1z M16,16c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C20,14.209,18.209,16,16,16z\"/></svg>`"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_1'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_2'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 3_3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3_3'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                disabled"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 4\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/s\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-4'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 5\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/k\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-5'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        active"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        children"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Sub level 5_1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/u\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-5_1'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            }]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 6\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"/k\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-6'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        title"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Top level 7\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-7'"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"default"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" () "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"TreeRef"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <>"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"?.collapse"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'level-3'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            >Expand \"Top level 3\"</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"br"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"#\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onClick"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".preventDefault"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"();"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_anyEl"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"document"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".querySelector"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'#demo-7-tree [data-slug=\"level-1_2\"]'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (_anyEl "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// insert a new <li>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"targetLi"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"_anyEl"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".closest"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'.nav-item'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"newLi"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"document"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".createElement"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"li\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"newLi"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".className "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'nav-item'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"newLi"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".innerHTML "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'<div tabindex=\"-1\" class=\"nav-link\" data-href=\"#new-item-here\" aria-expanded=\"false\" data-link=\"#new-item-here\" data-slug=\"level-new-item-here\" data-key=\"0-new-item-here\" data-optiondata=\"{}\"><span><i style=\"color:blue\">New Item Here</i></span></div>'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"targetLi"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"parentNode"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".insertBefore"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(newLi"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"targetLi"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".nextSibling);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"treeRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"current"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"?.updateParentTreeHeights"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(_anyEl);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            >Update the heights of all subtrees of \"Top level 1\" (Click repeatedly to view the effect) </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"           "}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Tree"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ref"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeRef}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"data"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{treeData} "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"showLine"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onSelect"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    e: "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"React"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".MouseEvent"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"HTMLElement"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    val: {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        key?"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        slug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        link"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                        optiondata"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"?:"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" string;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                ) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"console"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                }}  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            />"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    )"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h2 id="️-api">{"❤️ API"}</_components.h2>{"\n"}<_components.h3 id="tree">{"Tree"}</_components.h3>{"\n"}<_components.pre data-language="js" data-theme="default"><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Tree "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'funda-ui/Tree'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"ref"}</_components.code></_components.td><_components.td>{"React.ForwardedRef"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"It exposes the following methods of the component:  "}<br />{" "}<ol><li><_components.code>{"ref.current.collapse(slug: string);"}</_components.code>{": Expand the current item based on slug"}</li><li><_components.code>{"ref.current.updateParentTreeHeights(targetElement: HTMLElement);"}</_components.code>{": Pass in a target HTMLElement and it will find the top-level parent element. This function updates the heights of all nested <ul> elements within a tree structure by finding the topmost parent node and observing its DOM changes to ensure proper tree expansion/collapse animations."}</li></ol></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"treeClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td><_components.code>{"tree-diagram-default"}</_components.code></_components.td><_components.td>{"The class name of the tree."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"childClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td><_components.code>{"tree-diagram"}</_components.code></_components.td><_components.td>{"The class name of the child on "}<_components.code>{"<ul>"}</_components.code>{"."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"checkable"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Set TreeNode display Checkbox or not."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"showLine"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Shows a connecting line."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"lineStyle"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td><_components.code>{"dotted"}</_components.code>{" | "}<_components.code>{"dashed"}</_components.code>{" | "}<_components.code>{"solid"}</_components.code>{" | "}<_components.code>{"double"}</_components.code></_components.td><_components.td>{"Specifies what kind of line to display. By default it is \"solid\"."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"alternateCollapse"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Mutually exclusive alternate expansion between the first levels."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"renderOption"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"A function to render content of the option, replaces the default content of the option. It passes two parameters. "}<br />{" "}<ol><li>{"The first is the option data ("}<_components.strong>{"JSON Object"}</_components.strong>{")"}</li><li>{"The second is the key of the current option ("}<_components.strong>{"React.Key"}</_components.strong>{")"}</li></ol></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"arrow"}</_components.code></_components.td><_components.td>{"ReactNode"}</_components.td><_components.td><_components.code>{"<svg width=\"0.75em\" height=\"0.75em\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M15.795 11.272L7.795 16.272C6.79593 16.8964 5.5 16.1782 5.5 15L5.5 5.00002C5.5 3.82186 6.79593 3.1036 7.795 3.72802L15.795 8.72802C16.735 9.31552 16.735 10.6845 15.795 11.272Z\" fill=\"currentColor\"/></svg>"}</_components.code></_components.td><_components.td>{"Set an arrow of control"}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"arrowIcons"}</_components.code></_components.td><_components.td>{"React.ReactNode[]"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Set collapse/expand icon. Use an array to set two icons, if only one is set, the icon animation is activated, and if two are set, the animation is canceled. "}<br />{" such as: "}<_components.code>{"[<><svg width=\"1em\" height=\"1em\" viewBox=\"0 0 24 24\">...</svg></>,<><svg width=\"1em\" height=\"1em\" viewBox=\"0 0 24 24\">...</svg></>]"}</_components.code>{" "}<blockquote><_components.code>{"arrow"}</_components.code>{" will have no effect when using this attribute."}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"disableArrow"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Disable arrow."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"disableCollapse"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Disable the collapse effect."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"data"}</_components.code></_components.td><_components.td>{"array"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Specify data of Cascading List as a JSON string format. Such as: "}<br /><_components.code>{"[{title:\"Top level 1\",link:\"#\",slug:'level-1'},{title:\"Top level 2\",link:\"/s\",slug:'level-2',},{title:\"Top level 3\",link:\"https://example.com\",slug:'level-3',active:true,children:[{title:\"Sub level 3_1\",link:\"#3-1\",slug:'level-3_1'},{title:\"Sub level 3_2\",link:\"#3-2\",slug:'level-3_2'},{title:\"Sub level 3_3\",link:\"#3-3\",slug:'level-3_3'}]},{title:\"Top level 4 (heading)\",link:\"#\",slug:'level-4',}]"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"retrieveData"}</_components.code></_components.td><_components.td>{"array"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Specify data of showing items from "}<_components.code>{"data"}</_components.code>{". Such as: "}<br /><_components.code>{"[{title:\"Top level 1\",},{title:\"Sub level 2_2\"},{title:\"Sub level 3_3\"}]"}</_components.code>{" "}<blockquote>{"It will filter out other options that don't exist, usually used for real-time searches"}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onSelect"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Call a function when clicking an item. It returns three callback values. "}<br />{" "}<ol><li>{"The first is the current hyperlink Event ("}<_components.strong>{"Event"}</_components.strong>{")"}</li><li>{"The second is the data ("}<_components.strong>{"JSON Object"}</_components.strong>{")"}</li><li>{" The third is a callback function, which can initiate an asynchronous request to load children (usage: Please refer to the documentation "}<_components.a href="#load-data-asynchronously">{"example"}</_components.a>{") ("}<_components.strong>{"async Function"}</_components.strong>{")"}</li></ol></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onDoubleSelect"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"It fires when the mouse pointer double clicks a cell. It returns three callback values. "}<br />{" "}<ol><li>{"The first is the current hyperlink Event ("}<_components.strong>{"Event"}</_components.strong>{")"}</li><li>{"The second is the data ("}<_components.strong>{"JSON Object"}</_components.strong>{")"}</li><li>{" The third is a callback function, which can initiate an asynchronous request to load children (usage: Please refer to the documentation "}<_components.a href="#load-data-asynchronously">{"example"}</_components.a>{") ("}<_components.strong>{"async Function"}</_components.strong>{")"}</li></ol></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onCollapse"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Call a function when collapsing/expanding. It returns four callback values. "}<br />{" "}<ol><li>{"The first is the current hyperlink Event ("}<_components.strong>{"Event"}</_components.strong>{")"}</li><li>{"The second is the data ("}<_components.strong>{"JSON Object"}</_components.strong>{")"}</li><li>{" The third is a callback function, which can initiate an asynchronous request to load children (usage: Please refer to the documentation "}<_components.a href="#load-data-asynchronously">{"example"}</_components.a>{") ("}<_components.strong>{"async Function"}</_components.strong>{") "}</li><li>{"The last parameter is the state for determining whether to expand ("}<_components.strong>{"Boolean"}</_components.strong>{")"}</li></ol>{". "}<blockquote>{"When "}<_components.code>{"disableArrow"}</_components.code>{" is \"true\", click on the content to trigger it"}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onCheck"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Call a function when changing the checkbox. It returns only one callback value ("}<_components.strong>{"Array"}</_components.strong>{"). "}<blockquote>{"It is valid when "}<_components.code>{"checkable"}</_components.code>{" is \"true\""}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.p>{"Array configuration properties of the "}<_components.code>{"data"}</_components.code>{":"}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"title"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The title attribute is used to provide the label text of the hyperlink. "}<blockquote>{"Support html tags"}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"link"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Specify a URL address."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"active"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Activate current item. If true, it will be expanded by default (Non-asynchronous mode)."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"selected"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Selected current item."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"checked"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Whether the checkbox of the current item is selected."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"disabled"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"When present, it specifies that an option should be disabled."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"heading"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Is it just plain text. Usually used as a separator."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"icon"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Specify an icon string, which can be svg or classname."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"slug"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"specify a slug. It can be used for data query parameters"}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"childrenAsync"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Loading children asynchronously. Set to \"true\" to trigger loading event."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"children"}</_components.code></_components.td><_components.td>{"array"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Specify a set of sub-navigation, Eg. "}<_components.code>{"[{\"title\":\"Sub Sub Level 1\",\"link\":\"#\",\"slug\":\"level-1_0\",\"active\":true},{\"title\":\"Sub Sub Level 2\",\"link\":\"#\",\"slug\":\"level-2_0\"}]"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"customContentToHyperlink"}</_components.code></_components.td><_components.td>{"React.ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Add custom content to "}<_components.code>{"<a class=\"nav-link\">...</a>"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"customContentToLiTag"}</_components.code></_components.td><_components.td>{"React.ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Add custom content to "}<_components.code>{"<li class=\"nav-item\">...</li>"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"itemLinkMouseEnterCallback"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The mouseenter event of "}<_components.code>{"<a class=\"nav-link\"></a>"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"itemLinkMouseLeaveCallback"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The mouseleave event of "}<_components.code>{"<a class=\"nav-link\"></a>"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"itemMouseEnterCallback"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The mouseenter event of "}<_components.code>{"<li class=\"nav-item\"></li>"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"itemMouseLeaveCallback"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The mouseleave event of "}<_components.code>{"<li class=\"nav-item\"></li>"}</_components.code></_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.hr />{"\n"}<_components.p>{"Array configuration properties of the "}<_components.code>{"retrieveData"}</_components.code>{":"}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"title"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Specify the label text for each option."}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.hr />{"\n"}<_components.p>{"The property list of the last parameter (Function) in the return value of "}<_components.code>{"onCollapse"}</_components.code>{" and "}<_components.code>{"onSelect"}</_components.code>{":"}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"key"}</_components.code></_components.td><_components.td>{"React.Key | null"}</_components.td><_components.td>{"null"}</_components.td><_components.td>{"Match the key value of item."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"fetch"}</_components.code></_components.td><_components.td>{"JSON Object | null"}</_components.td><_components.td>{"null"}</_components.td><_components.td>{"Set a request."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"firstRender"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"false"}</_components.td><_components.td>{"Is it the first render."}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.blockquote>{"\n"}<_components.p>{"The object properties of "}<_components.code>{"fetch"}</_components.code>{":"}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"fetchFuncAsync"}</_components.code></_components.td><_components.td>{"Constructor"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"A method as a string from the constructor."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"fetchFuncMethod"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"When the property is "}<_components.em>{"true"}</_components.em>{", every time the select changes, a data request will be triggered. "}<br /><blockquote>{"The methord must be a Promise Object."}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"fetchFuncMethodParams"}</_components.code></_components.td><_components.td>{"array"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The parameter passed by the method, it is an array. "}<br />{"Note: the first element is a query string, the second element is the number of queried data (usually a number), and then you can increase the third, or fourth, and more parameters. "}<br />{"Such as "}<_components.code>{"['',0]"}</_components.code>{", "}<_components.code>{"['',99,'string 1','string 2']"}</_components.code>{" "}<br /><blockquote>{"There should be at least one parameter which is the query string."}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"fetchCallback"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Return value from "}<_components.code>{"fetchCallback"}</_components.code>{" property to format the data of the API callback, which will match the data structure of the component. "}<br />{"At the same time it returns the original data, you will use this function and use the "}<_components.code>{"return"}</_components.code>{" keyword to return a new value. "}<blockquote>{"Among them, "}<_components.code>{"title"}</_components.code>{", "}<_components.code>{"link"}</_components.code>{" and "}<_components.code>{"slug"}</_components.code>{" are attributes used by the system, and other attributes can be added freely"}</blockquote></_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}</_components.blockquote></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/Web-Elements/Tree.html.mdx","route":"/Web-Elements/Tree.html","timestamp":1768462508000,"pageMap":[{"kind":"Folder","name":"Applications","route":"/Applications","children":[{"kind":"Meta","data":{"collecting-data.html":"Collecting Data"}},{"kind":"MdxPage","name":"collecting-data.html","route":"/Applications/collecting-data.html"}]},{"kind":"Folder","name":"Forms","route":"/Forms","children":[{"kind":"MdxPage","name":"CascadingSelect.html","route":"/Forms/CascadingSelect.html"},{"kind":"MdxPage","name":"CascadingSelectE2E.html","route":"/Forms/CascadingSelectE2E.html"},{"kind":"MdxPage","name":"Checkbox.html","route":"/Forms/Checkbox.html"},{"kind":"MdxPage","name":"ColorPicker.html","route":"/Forms/ColorPicker.html"},{"kind":"MdxPage","name":"Date.html","route":"/Forms/Date.html"},{"kind":"MdxPage","name":"DynamicFields.html","route":"/Forms/DynamicFields.html"},{"kind":"MdxPage","name":"File.html","route":"/Forms/File.html"},{"kind":"MdxPage","name":"Input.html","route":"/Forms/Input.html"},{"kind":"MdxPage","name":"LiveSearch.html","route":"/Forms/LiveSearch.html"},{"kind":"MdxPage","name":"MultipleCheckboxes.html","route":"/Forms/MultipleCheckboxes.html"},{"kind":"MdxPage","name":"MultipleSelect.html","route":"/Forms/MultipleSelect.html"},{"kind":"MdxPage","name":"NativeSelect.html","route":"/Forms/NativeSelect.html"},{"kind":"MdxPage","name":"NumberInput.html","route":"/Forms/NumberInput.html"},{"kind":"MdxPage","name":"Radio.html","route":"/Forms/Radio.html"},{"kind":"MdxPage","name":"RangeSlider.html","route":"/Forms/RangeSlider.html"},{"kind":"MdxPage","name":"SearchBar.html","route":"/Forms/SearchBar.html"},{"kind":"MdxPage","name":"Select.html","route":"/Forms/Select.html"},{"kind":"MdxPage","name":"Switch.html","route":"/Forms/Switch.html"},{"kind":"MdxPage","name":"TagInput.html","route":"/Forms/TagInput.html"},{"kind":"MdxPage","name":"Textarea.html","route":"/Forms/Textarea.html"},{"kind":"Meta","data":{"CascadingSelect.html":"Cascading Select","CascadingSelectE2E.html":"Cascading Select End-to-end 🔥","Checkbox.html":"Checkbox","ColorPicker.html":"Color Picker","Date.html":"Date 🔥","DynamicFields.html":"Dynamic Fields 🔥","File.html":"File","Input.html":"Input 🤖","LiveSearch.html":"Live Search","MultipleCheckboxes.html":"Multiple Checkboxes","MultipleSelect.html":"Multiple Select 🔥","NativeSelect.html":"Native Select","NumberInput.html":"Number Input","Radio.html":"Radio","RangeSlider.html":"Range Slider","SearchBar.html":"Search Bar","Select.html":"Select 🔥","Switch.html":"Switch","TagInput.html":"Tag Input","Textarea.html":"Textarea 🤖"}}]},{"kind":"Folder","name":"Getting-Started","route":"/Getting-Started","children":[{"kind":"MdxPage","name":"Installation.html","route":"/Getting-Started/Installation.html"},{"kind":"MdxPage","name":"Usage.html","route":"/Getting-Started/Usage.html"},{"kind":"Meta","data":{"Installation.html":"Installation","Usage.html":"Usage"}}]},{"kind":"Folder","name":"Hooks","route":"/Hooks","children":[{"kind":"Meta","data":{"useKeyPress.html":"useKeyPress","usePageVisibility.html":"usePageVisibility","useThrottle.html":"useThrottle","useDebounce.html":"useDebounce","useComId.html":"useComId","useInterval.html":"useInterval","useWindowScroll.html":"useWindowScroll","useAutosizeTextArea.html":"useAutosizeTextArea","useClickOutside.html":"useClickOutside","useDraggable.html":"useDraggable","useBoundedDrag.html":"useBoundedDrag","useStreamController.html":"useStreamController","useHistoryTracker.html":"useHistoryTracker","useSSE.html":"useSSE"}},{"kind":"MdxPage","name":"useAutosizeTextArea.html","route":"/Hooks/useAutosizeTextArea.html"},{"kind":"MdxPage","name":"useBoundedDrag.html","route":"/Hooks/useBoundedDrag.html"},{"kind":"MdxPage","name":"useClickOutside.html","route":"/Hooks/useClickOutside.html"},{"kind":"MdxPage","name":"useComId.html","route":"/Hooks/useComId.html"},{"kind":"MdxPage","name":"useDebounce.html","route":"/Hooks/useDebounce.html"},{"kind":"MdxPage","name":"useDraggable.html","route":"/Hooks/useDraggable.html"},{"kind":"MdxPage","name":"useHistoryTracker.html","route":"/Hooks/useHistoryTracker.html"},{"kind":"MdxPage","name":"useInterval.html","route":"/Hooks/useInterval.html"},{"kind":"MdxPage","name":"useKeyPress.html","route":"/Hooks/useKeyPress.html"},{"kind":"MdxPage","name":"usePageVisibility.html","route":"/Hooks/usePageVisibility.html"},{"kind":"MdxPage","name":"useSSE.html","route":"/Hooks/useSSE.html"},{"kind":"MdxPage","name":"useStreamController.html","route":"/Hooks/useStreamController.html"},{"kind":"MdxPage","name":"useThrottle.html","route":"/Hooks/useThrottle.html"},{"kind":"MdxPage","name":"useWindowScroll.html","route":"/Hooks/useWindowScroll.html"}]},{"kind":"Folder","name":"Interaction","route":"/Interaction","children":[{"kind":"MdxPage","name":"DragDropList.html","route":"/Interaction/DragDropList.html"},{"kind":"MdxPage","name":"HorizontalScrollContent.html","route":"/Interaction/HorizontalScrollContent.html"},{"kind":"MdxPage","name":"ModeSwitch.html","route":"/Interaction/ModeSwitch.html"},{"kind":"MdxPage","name":"Refresher.html","route":"/Interaction/Refresher.html"},{"kind":"MdxPage","name":"ScrollReveal.html","route":"/Interaction/ScrollReveal.html"},{"kind":"MdxPage","name":"Scrollbar.html","route":"/Interaction/Scrollbar.html"},{"kind":"Meta","data":{"DragDropList.html":"DragDrop List 🔥","HorizontalScrollContent.html":"Horizontal Scroll Content","ModeSwitch.html":"Mode Switch","Refresher.html":"Refresher","Scrollbar.html":"Custom Scrollbar","ScrollReveal.html":"Scroll Reveal"}}]},{"kind":"Folder","name":"Layouts","route":"/Layouts","children":[{"kind":"MdxPage","name":"MasonryLayout.html","route":"/Layouts/MasonryLayout.html"},{"kind":"MdxPage","name":"RootPortal.html","route":"/Layouts/RootPortal.html"},{"kind":"MdxPage","name":"SplitterPanel.html","route":"/Layouts/SplitterPanel.html"},{"kind":"Meta","data":{"MasonryLayout.html":"Masonry Layout","RootPortal.html":"Root Portal","SplitterPanel.html":"Splitter Panel"}}]},{"kind":"Folder","name":"Navigation","route":"/Navigation","children":[{"kind":"MdxPage","name":"DropdownMenu.html","route":"/Navigation/DropdownMenu.html"},{"kind":"MdxPage","name":"MultilevelDropdownMenu.html","route":"/Navigation/MultilevelDropdownMenu.html"},{"kind":"Meta","data":{"DropdownMenu.html":"Dropdown Menu","MultilevelDropdownMenu.html":"Multilevel Dropdown Menu"}}]},{"kind":"Folder","name":"Web-Elements","route":"/Web-Elements","children":[{"kind":"MdxPage","name":"Accordion.html","route":"/Web-Elements/Accordion.html"},{"kind":"MdxPage","name":"BackToTop.html","route":"/Web-Elements/BackToTop.html"},{"kind":"MdxPage","name":"Chatbox.html","route":"/Web-Elements/Chatbox.html"},{"kind":"MdxPage","name":"DigitalClock.html","route":"/Web-Elements/DigitalClock.html"},{"kind":"MdxPage","name":"EventCalendar.html","route":"/Web-Elements/EventCalendar.html"},{"kind":"MdxPage","name":"EventCalendarTimeline.html","route":"/Web-Elements/EventCalendarTimeline.html"},{"kind":"MdxPage","name":"ModalDialog.html","route":"/Web-Elements/ModalDialog.html"},{"kind":"MdxPage","name":"Pagination.html","route":"/Web-Elements/Pagination.html"},{"kind":"MdxPage","name":"Popover.html","route":"/Web-Elements/Popover.html"},{"kind":"MdxPage","name":"ShowMoreLess.html","route":"/Web-Elements/ShowMoreLess.html"},{"kind":"MdxPage","name":"Stepper.html","route":"/Web-Elements/Stepper.html"},{"kind":"MdxPage","name":"Table.html","route":"/Web-Elements/Table.html"},{"kind":"MdxPage","name":"Tabs.html","route":"/Web-Elements/Tabs.html"},{"kind":"MdxPage","name":"Toast.html","route":"/Web-Elements/Toast.html"},{"kind":"MdxPage","name":"Tooltip.html","route":"/Web-Elements/Tooltip.html"},{"kind":"MdxPage","name":"Tree.html","route":"/Web-Elements/Tree.html"},{"kind":"Meta","data":{"Accordion.html":"Accordion","BackToTop.html":"Back To Top","Chatbox.html":"Chatbox 🔥🤖","DigitalClock.html":"Digital Clock","EventCalendar.html":"Event Calendar 🔥","EventCalendarTimeline.html":"Event Calendar Timeline 🔥","ModalDialog.html":"Modal Dialog 🔥","Popover.html":"Popover 🔥","Pagination.html":"Pagination","ShowMoreLess.html":"Show More Less","Stepper.html":"Stepper","Table.html":"Table 🔥","Tabs.html":"Tabs","Toast.html":"Toast","Tooltip.html":"Tooltip","Tree.html":"Tree 🔥"}}]},{"kind":"Meta","data":{"index":"Introduction","Getting-Started":"","---":{"type":"separator","title":"Components"},"Applications":"","Forms":"","Web-Elements":"","Navigation":"","Interaction":"","Layouts":"","contact":{"title":"Source ↗","type":"page","href":"https://github.com/xizon/funda-ui","newWindow":true}}},{"kind":"MdxPage","name":"index","route":"/"}],"flexsearch":{"codeblocks":true},"title":"Tree",headings:__toc},
  pageNextRoute: "/Web-Elements/Tree.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)